import generateBasicEntityActions from './generateBasicEntityActions';
import * as schemas from '../schemas';

const assetSpreadsheetActions = generateBasicEntityActions('assetSpreadsheets', 'assetSpreadsheet');

assetSpreadsheetActions.create = (spreadsheet) => {
  const { file, ...spreadsheetParams } = spreadsheet;
  return {
    API_CALL: {
      httpMethod: 'POST',
      endpoint: 'assetSpreadsheets',
      params: { assetSpreadsheet: spreadsheetParams },
      attachments: { file },
      schema: { assetSpreadsheet: schemas.assetSpreadsheet },
    },
  };
};

assetSpreadsheetActions.reimport = id => ({
  API_CALL: {
    httpMethod: 'PUT',
    endpoint: `assetSpreadsheets/${id}/reimport`,
    schema: { spreadsheet: schemas.spreadsheet },
  },
});

export default assetSpreadsheetActions;
